import React, { Component } from "react";
import TabBorderItem from "./items/border";
import AfshanTabBackgroundItem from "./items/afshanBackground";

export default class AfshanTabItems extends Component {
  render() {
    return (
      <ul className="ul-background-select">
        <TabBorderItem
          texts={this.props.texts}
          activePartsTab={this.props.activePartsTab}
          partsTabHandler={this.props.partsTabHandler}
        />
        <AfshanTabBackgroundItem
          texts={this.props.texts}
          activePartsTab={this.props.activePartsTab}
          partsTabHandler={this.props.partsTabHandler}
        />
      </ul>
    );
  }
}
